const sorry_items=[
    {
    id:36,
    item_name:'3D Heart',
    item_price:100,
    image:'/images/sorry/3DHeart.jpg',
    item_stock:0,
    info:'Hybrid tea roses, the products of a cross between hybrid perpetual roses and old-fashioned tea roses, are rose royalty. They are the most popular roses in the world and perhaps the most popular flowers. Hybrid teas have all the virtues you look for in a flower: beauty, fragrance, and easy care.'

    }
    ,
    {
        id:37,
        item_name:'Bake & Gifts',
        item_price:19,
        image:'/images/sorry/Bake&Gifts.jpg',
        item_stock:8,
        info:'Polyantha roses are compact, dwarf shrubs with closely packed bunches of small usually semi-double or double flowers in colours including white, cream, peach, shades of pink or red. Sprays will flower throughout the summer and these roses grow from 30-90cm (2-3ft) high.'
        
    }
    ,
    {
        id:38,
        item_name:'Basket of Red',
        item_price:99,
        image:'/images/sorry/BasketofRed.jpg',
        item_stock:1,
        info:'Produced by crossing hybrid tea roses and polyantha roses, floribundas are typically smaller and bushier than hybrid tea roses, and more upright than polyanthas. If youre seeking roses for fragrance, take a look at our pick of the top roses to grow for scent. More on growing roses: Guide to growing roses in pots.'
    }
    ,
    {
        id:39,
        item_name:'Big Heart',
        item_price:180,
        image:'/images/sorry/BigHeart.jpg',
        item_stock:10,
        info:'A patio rose is a miniature floribunda rose that can come in a variety of styles. ... Patio roses do not require too much maintenance and are smaller than the average rose (the clue is in the name!). These types of roses are actually good for slope and erosion control.'
    }

    ,
    {
        id:40,
        item_name:'Expressive Love',
        item_price:200,
        image:'/images/sorry/ExpressiveLove.jpg',
        item_stock:1,
        info:'Climbing roses for north-facing or shady walls · English Shrub roses make good climbers and will flower on a north-facing wall, pillar or arch. '

    }
    ,
    {
        id:41,
        item_name:'Heart to Heart',
        item_price:210,
        image:'/images/sorry/HearttoHeart.jpg',
        item_stock:1,
        info:'the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and consectetur, from a Lorem Ipsum passage, and consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical'
    }
    ,
    {
        id:42,
        item_name:'Pink Heart',
        item_price:10,
        image:'/images/sorry/PinkHeart.jpg',
        item_stock:10,
        info:'Rosa × damascena, more commonly known as the Damask rose, or sometimes as the rose of Castile, is a rose hybrid, derived from Rosa gallica and Rosa moschata. Further DNA analysis has shown that a third species, Rosa fedtschenkoana, is associated with the Damask rose'
    }
    ,
    {
        id:43,
        item_name:'Pink Sorry',
        item_price:10,
        image:'/images/sorry/PinkSorry.jpg',
        item_stock:10,
        info:'et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem'
    }
    ,
    {
        id:44,
        item_name:'Teddy Heart',
        item_price:10,
        image:'/images/sorry/TeddyHeart.jpg',
        item_stock:10,
        info:'et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem'
    }
    ,
    {
        id:45,
        item_name:'Teddy & 30 Roses',
        item_price:10,
        image:'/images/sorry/Teddy&30Roses.jpg',
        item_stock:10,
        info:'he standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and'
    }
    ,
    {
        id:46,
        item_name:'Ten Roses',
        item_price:10,
        image:'/images/sorry/TenRoses.jpg',
        item_stock:10,
        info:'1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
    }
    ,
    {
        id:47,
        item_name:'White&Red',
        item_price:10,
        image:'/images/sorry/White&Red.jpg',
        item_stock:10,
        info:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected'
    }
];
export default sorry_items;